$(document).on('turbolinks:load', function() {
  flatpickr(".flatpickr:not(.-lazy-load)", {
    dateFormat: "m/d/Y"
  })
})
